// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class NotificationTypeChannelResource extends Resource {
    basePath: string = 'notifications/notification-types/{parent}/channels/';

    objectPath: string = 'notifications/notification-types/{parent}/channels/{ident}/';
}
